import { Component } from '@angular/core';
import { WsLandingService } from 'src/app/ws/wsLanding/ws-landing.service';
import { lastValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { SharedPrefrences } from 'src/app/utils/utils.service';
import { WsShopallService } from 'src/app/ws/wsShopAll/ws-shopall.service';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
import { MAddUpdateCartModule, MAddUpdateCartModuleResponse } from '../product-detail-updated/product-detail-updated.module';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginPopupComponent } from 'src/app/components/login-popup/login-popup.component';
import { MGenderSupplimentRequest, MTrendingProductRequest } from '../homepage/homepage.module';
import { WsUserProfileService } from 'src/app/ws/wsUserProfile/ws-user-profile.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent {
  supplimentProducts: any = [];
  mTrendingProductReq: MTrendingProductRequest = new MTrendingProductRequest();
  msupplimentReq: MGenderSupplimentRequest = new MGenderSupplimentRequest();
  mAddUpdateCartModule: MAddUpdateCartModule = new MAddUpdateCartModule();
  mAddUpdateCartModuleResponse: any = new MAddUpdateCartModuleResponse()
  supplimentCounts: any;
  productType: any;
  trendingProducts: any = [];
  trendingCount: any;
  totalRecords = 0
  type: any;
  mWishlistData: any = [];

  constructor(private wsUserProfileService: WsUserProfileService, private modalService: NgbModal, private wslandingservice: WsLandingService, private router: Router, private wsShopAllService: WsShopallService, private _commonBehaviorChangeService: CommonBehaviorChangeService) {

    this._commonBehaviorChangeService.currentrCartList.subscribe((cartList: any) => {
      this.mAddUpdateCartModuleResponse.data = cartList.data;
      this.supplimentProducts && this.supplimentProducts.length > 0 && this.supplimentProducts.forEach((product: any) => {
        const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
        if (cartPresent.length > 0) {
          product.cartQty = cartPresent[0].qty;
        }
      })
      this.trendingProducts && this.trendingProducts.length > 0 && this.trendingProducts.forEach((product: any) => {
        const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
        if (cartPresent.length > 0) {
          product.cartQty = cartPresent[0].qty;
        }
      })
      this.mWishlistData && this.mWishlistData.length > 0 && this.mWishlistData.forEach((product: any) => {
        const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product['productdetail'].id && el.qty > 0) });
        if (cartPresent.length > 0) {
          product['productdetail'].cartQty = cartPresent[0].qty;
        }
      })
    })

    this._commonBehaviorChangeService.currentWishList.subscribe((wishList: any) => {
      this.mWishlistData = wishList;

      this.mWishlistData && this.mWishlistData.length > 0 && this.mWishlistData.forEach((product: any) => {
        const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product['productdetail'].id && el.qty > 0) });
        if (cartPresent.length > 0) {
          product['productdetail'].cartQty = cartPresent[0].qty;
        }
      })
    })
  }
  ngOnInit() {
    this.productType = this.router.url.split('/')[2]
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.getAllCartProducts();
    } else {
      if (this.productType == 'supplements') {
        this.msupplimentReq.take = 10;
        this.msupplimentReq.skip = 0;
        this.msupplimentReq.gender = "2"; // Gender type 2=> Female 
        this.msupplimentReq.is_suppliment = true;
        this.getSuppliments(this.msupplimentReq)
      } else if (this.productType == 'trending') {
        this.mTrendingProductReq.take = 10;
        this.mTrendingProductReq.skip = 0;
        this.getTrendingProduct(this.mTrendingProductReq)
      } else if (this.productType == 'wishlist') {
        if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
          this.getWishList();
        }
      }
    }

  }

  /**
 * Date:- 21-06-2023
 * Method :- This method is used to Get Order Detail List
 * @param userId :-  This param is used for request to Get Order Detail List
 */
  async getWishList() {
    const wishList = this.wsUserProfileService.getWishList("" + SharedPrefrences.getUserId())
    await lastValueFrom(wishList).then(async response => {
      if (response && response.statusCode == 200) {
        this.mWishlistData = response.data
        this.mWishlistData.forEach((product: any) => {
          const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product['productdetail'].id && el.qty > 0) });
          if (cartPresent.length > 0) {
            product['productdetail'].cartQty = cartPresent[0].qty;
          }
        })
        if (this.productType == 'supplements') {
          this.msupplimentReq.take = 10;
          this.msupplimentReq.skip = 0;
          this.msupplimentReq.gender = "2"; // Gender type 2=> Female 
          this.msupplimentReq.is_suppliment = true;
          this.getSuppliments(this.msupplimentReq)
        } else if (this.productType == 'trending') {
          this.mTrendingProductReq.take = 10;
          this.mTrendingProductReq.skip = 0;
          this.getTrendingProduct(this.mTrendingProductReq)
        }
      }
    })
  }


  /**
   * Date: 10-06-23
   * Method : This method is used to get all cart items 
   */
  async getAllCartProducts() {
    const getAllCart = this.wsShopAllService.getCartList("" + SharedPrefrences.getUserId())
    await lastValueFrom(getAllCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModuleResponse.data = response.data;
        this.getWishList();
      } else {
      }
    })
  }


  /**
 * Date:- 10-06-2023
 * Method :- This method is used to get Suppliment Products
 * @param suppimentReq :-  This param is used to get Suppliment Products
 */
  async getSuppliments(suppimentReq: any) {
    if (suppimentReq.skip == 0) {
      this.supplimentProducts = []
    }
    const listSuppliment = this.wslandingservice.getPoductByGenderSuppiment(suppimentReq)
    await lastValueFrom(listSuppliment).then(async response => {
      if (response && response.statusCode == 200) {
        this.totalRecords = response.totalRecords
        if (this.supplimentProducts.length < 1) {
          this.supplimentProducts = response.data
          if (this.mWishlistData && this.mWishlistData.length > 0) {
            this.supplimentProducts.forEach((product: any) => {
              const present = this.mWishlistData.some(function (el: any) { return (el && el.productdetail && el.productdetail.id === product.id && el.qty > 0) });
              if (present) {
                product['like'] = true;
              }
            })
          }
          if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
            this.supplimentProducts.forEach((product: any) => {
              const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
              if (cartPresent.length > 0) {
                product.cartQty = cartPresent[0].qty;
              }
            })
          }
        } else {
          response.data.forEach((product: any) => {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              response.data[present]['like'] = true;
            }
            const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (cartPresent.length > 0) {
              product.cartQty = cartPresent[0].qty;
            }
          })
          this.supplimentProducts = [...this.supplimentProducts, ...response.data]
        }

        this.supplimentCounts = this.supplimentProducts.length;
      }
    })
  }

  /**
 * Date:- 10-06-2023
 * Method :- This method is used to get Trending Products
 * @param trendingProductReq :-  This param is used to get Trending Products
 */
  async getTrendingProduct(trendingProductReq: any) {
    if (trendingProductReq.skip == 0) {
      this.trendingProducts = []
    }
    const listTrendingProduct = this.wslandingservice.getTrendingPoduct(trendingProductReq)
    await lastValueFrom(listTrendingProduct).then(async response => {
      if (response && response.statusCode == 200) {
        this.totalRecords = response.totalRecords
        if (this.trendingProducts.length < 1) {
          this.trendingProducts = response.data
          if (this.mWishlistData && this.mWishlistData.length > 0) {
            this.trendingProducts.forEach((product: any) => {
              const present = this.mWishlistData.some(function (el: any) { return (el && el.productdetail && el.productdetail.id === product.id && el.qty > 0) });
              if (present) {
                product['like'] = true;
              }
            })
          }
          if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
            this.trendingProducts.forEach((product: any) => {
              const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
              if (cartPresent.length > 0) {
                product.cartQty = cartPresent[0].qty;
              }
            })
          }
        } else {
          response.data.forEach((product: any) => {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              response.data[present]['like'] = true;
            }
            const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (cartPresent.length > 0) {
              product.cartQty = cartPresent[0].qty;
            }
          })
          this.trendingProducts = [...this.trendingProducts, ...response.data]
        }

        this.trendingCount = this.trendingProducts.length;
      }
    })
  }

  onScrollSupplimentProduct() {
    if (this.supplimentCounts < this.totalRecords) {
      this.msupplimentReq.skip = this.supplimentCounts;
      this.getSuppliments(this.msupplimentReq);
    }
  }

  onScrollTrendingProduct() {
    if (this.trendingCount < this.totalRecords) {
      this.mTrendingProductReq.skip = this.trendingCount;
      this.getTrendingProduct(this.mTrendingProductReq);
    }
  }

  showProduct(product: any) {
    var productName = product.name.split(' ').join('_').replace(',', '')
    this.router.navigate(["/product-detail-updated/" + product.id + '/' + productName.replace(/[&\/\#,+()$~%.'":*?<>{}]/g, '_')])
  }

  async addToCartCommon(product: any, index?: any, productType?: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.id;
    if (this.type == 'cart') {
      this.mAddUpdateCartModule.iswishlistitem = false;
    } else {
      this.mAddUpdateCartModule.iswishlistitem = true;
    }
    if (this.type == "cart") {
      const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
      if (cart > -1) {
        this.mAddUpdateCartModule.qty = this.mAddUpdateCartModuleResponse.data[cart].qty + 1;
        this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
      } else {
        this.mAddUpdateCartModule.qty = 1;
      }
      const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
      await lastValueFrom(addRemoveProductFromCart).then(async response => {
        if (response && response.statusCode == 200) {
          this.mAddUpdateCartModule = new MAddUpdateCartModule();
          this._commonBehaviorChangeService.addCart(true);
        } else {
          console.log("something went wrong")
        }
      })
    } else {
      if (productType == 'wishList') {
        const wishlist = this.mWishlistData && this.mWishlistData.findIndex((wishlist: any) => { return wishlist.product_id === product.id })
        if (wishlist > -1) {
          this.mAddUpdateCartModule.id = this.mWishlistData[wishlist].id;
        }
        this.mAddUpdateCartModule.qty = 0;
      } else {
        this.mAddUpdateCartModule.iswishlistitem = product.like ? false : true;
        if (product.like) {
          const wishlist = this.mWishlistData && this.mWishlistData.findIndex((wishlist: any) => { return wishlist.product_id === product.id })
          if (wishlist > -1) {
            this.mAddUpdateCartModule.id = this.mWishlistData[wishlist].id;
          }
        }
        this.mAddUpdateCartModule.qty = product.like ? 0 : 1;
      }
      const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
      await lastValueFrom(addRemoveProductFromCart).then(async response => {
        if (response && response.statusCode == 200) {
          this._commonBehaviorChangeService.addWishlist(true)
          if (productType == 'suppliment') {
            this.supplimentProducts[index].like = this.mAddUpdateCartModule.iswishlistitem
          }
          if (productType == 'trending') {
            this.trendingProducts[index].like = this.mAddUpdateCartModule.iswishlistitem
          }
          if (productType == 'wishList') {
            this.mWishlistData.splice(index, 1)
          }
          this._commonBehaviorChangeService.addWishlist(true)
        } else {
          console.log("something went wrong")
        }
      })
    }
  }

  async addtoCart(product: any, val: any, index?: any, productType?: any) {
    this.type = val;
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.addToCartCommon(product, index, productType)
    } else {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.addToCartCommon(product, index, productType)
        }
      })
    }
  }

  buyNowCommon(product: any) {
    const productDetail = {
      qty: 1,
      productId: product.id
    }
    localStorage.setItem("buynow", JSON.stringify(productDetail))
    const userAgent = window.navigator.userAgent.toLowerCase();
    var mobile = /iphone|ipad|ipod|android|blackberry|iemobile|opera mini/i.test(userAgent)
    if (mobile) {
      this.router.navigate(["/checkout-new-mob/buynow/" + product.id])
    } else {
      this.router.navigate(["/checkout-new/buynow/" + product.id])
    }
  }

  buyNow(product: any) {
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.buyNowCommon(product)
    } else {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.buyNowCommon(product)
        }
      })
    }
  }

  async addCartItem(product: any, index: any, type: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.id;
    if (type == 'suppliment') {
      this.supplimentProducts[index]['cartQty'] = this.supplimentProducts[index]['cartQty'] + 1
      this.mAddUpdateCartModule.qty = this.supplimentProducts[index]['cartQty']
    } else if (type == 'trending') {
      this.trendingProducts[index]['cartQty'] = this.trendingProducts[index]['cartQty'] + 1
      this.mAddUpdateCartModule.qty = this.trendingProducts[index]['cartQty']
    } else {
      this.mWishlistData[index]['productdetail']['cartQty'] = this.mWishlistData[index]['productdetail']['cartQty'] + 1
      this.mAddUpdateCartModule.qty = this.mWishlistData[index]['productdetail']['cartQty']
    }
    this.mAddUpdateCartModule.iswishlistitem = false;
    const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
    if (cart > -1) {
      this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
    }
    const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
    await lastValueFrom(addRemoveProductFromCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModule = new MAddUpdateCartModule();
        this._commonBehaviorChangeService.addCart(true);
      } else {
        console.log("something went wrong")
      }
    })
  }

  async removeCartItem(product: any, index: any, type: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.id;
    this.mAddUpdateCartModule.iswishlistitem = false;
    const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
    if (cart > -1) {
      this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
    }
    if (product.cartQty > 0) {
      if (type == 'suppliment') {
        this.supplimentProducts[index]['cartQty'] = this.supplimentProducts[index]['cartQty'] - 1
        this.mAddUpdateCartModule.qty = this.supplimentProducts[index]['cartQty']
      } else if (type == 'trending') {
        this.trendingProducts[index]['cartQty'] = this.trendingProducts[index]['cartQty'] - 1
        this.mAddUpdateCartModule.qty = this.trendingProducts[index]['cartQty']
      } else {
        this.mWishlistData[index]['productdetail']['cartQty'] = this.mWishlistData[index]['productdetail']['cartQty'] - 1
        this.mAddUpdateCartModule.qty = this.mWishlistData[index]['productdetail']['cartQty']
      }
    } else {
      this.mAddUpdateCartModule.qty = 0;
      if (type == 'suppliment') {
        delete this.supplimentProducts[index]['cartQty']
      } else if (type == 'trending') {
        delete this.trendingProducts[index]['cartQty']
      } else {
        delete this.mWishlistData[index]['productdetail']['cartQty']
      }
    }
    const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
    await lastValueFrom(addRemoveProductFromCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModule = new MAddUpdateCartModule();
        this._commonBehaviorChangeService.addCart(true);
      } else {
        console.log("something went wrong")
      }
    })
  }
}